export default __webpack_public_path__ + "static/media/Architecture.9449f221.jpg";